import { LogLevel, StsConfigHttpLoader } from 'angular-auth-oidc-client';
import { of } from 'rxjs';
import { AppSettingsService } from '@capital-access/common/settings';
import { ImpersonationConfigService } from '@capital-access/common/user';
import { Settings } from './oidc-settings.model';

const IDP_SESSION_KEY = 'ca:idp';
const IDP_ACTIVE_KEY = 'ca:activeIdp';

const getUrl = (route: string) => `${location.origin}${route}`;

// TODO: Remove once fully switched to Okta.
function resolveIdpProvider(defaultProvider: string | undefined): string {
  const urlParam = new URLSearchParams(location.search).get('idp');
  if (urlParam) {
    sessionStorage.setItem(IDP_SESSION_KEY, urlParam);
  }
  return sessionStorage.getItem(IDP_SESSION_KEY) ?? defaultProvider ?? '';
}

// TODO: Remove once fully switched to Okta.
function clearAuthStateIfProviderChanged(resolvedIdp: string): void {
  const activeIdp = localStorage.getItem(IDP_ACTIVE_KEY);
  if (activeIdp !== null && activeIdp.toLowerCase() !== resolvedIdp.toLowerCase()) {
    localStorage.clear();
  }
  localStorage.setItem(IDP_ACTIVE_KEY, resolvedIdp);
}

export function configLoaderFactory(settingsService: AppSettingsService) {
  const appSettings = settingsService.getSettings<Settings>();
  const idp = resolveIdpProvider(appSettings.defaultOidcProvider);
  clearAuthStateIfProviderChanged(idp);
  const isOkta = idp.toLowerCase() === 'okta';
  const settings = isOkta ? appSettings.oktaOidc : appSettings.oidc;

  if (!settings) {
    throw new Error(`Can not configure authentication. Oidc settings are not initialized.`);
  }

  const isImpersonating = ImpersonationConfigService.isImpersonating(settings.clientId);
  const scope = isImpersonating ? ImpersonationConfigService.mergeImpersonationScopes(settings.scope) : settings.scope;

  const config = {
    authority: settings.stsServer,
    redirectUrl: getUrl(settings.redirectRoute),
    postLoginRoute: settings.postLoginRoute,
    postLogoutRedirectUri: getUrl(settings.postLogoutRedirectRoute),
    clientId: settings.clientId,
    scope: scope,
    responseType: settings.responseType,
    silentRenew: settings.silentRenew,
    renewTimeBeforeTokenExpiresInSeconds: settings.renewBeforeExpirationInSec,
    disableIatOffsetValidation: settings.disableIatOffsetValidation,
    unauthorizedRoute: settings.unauthorizedRoute,
    logLevel: LogLevel.Error,
    // To avoid redirection after login via pop-up
    triggerAuthorizationResultEvent: true,
    useRefreshToken: settings.useRefreshToken,
    triggerRefreshWhenIdTokenExpired: settings.triggerRefreshWhenIdTokenExpired
  };

  return new StsConfigHttpLoader(of(config));
}
